import { JSX } from 'react';
import '@src/components/legal/index.scss';

export const LegalText = ({
  className = '',
  prefix,
  showMultiVendorSuffix = true,
}: {
  prefix?: 'AFFIDAVIT' | 'PRIVACY';
  showMultiVendorSuffix?: boolean;
  className?: string;
}): JSX.Element => {
  return (
    <div id="legal-text" className={className}>
      <div className="hc-pet-insurance__legal--text">
        {prefix === 'PRIVACY' ? (
          <div>
            <div className="privacy-mobile" data-testid="privacy-mobile">
              <div>
                <div className="legal-intro">
                  <h1>We&apos;re Working with Trupanion &amp; Lemonade</h1>
                  <p>To generate your quotes we&apos;ll share:</p>
                  <ul>
                    <li>The personal, pet, and vet data you provided</li>
                    <li>The email address of your Chewy account</li>
                  </ul>
                </div>
                <h1>When You Agree &amp; Continue...</h1>
                <ul className="consent">
                  <li>
                    You direct Chewy, Chewy Insurance, Trupanion, and Lemonade
                    to share that information.
                  </li>
                  <li>
                    You also agree to the Terms of Use for each: Chewy, Chewy
                    Insurance, Trupanion, and Lemonade.
                  </li>
                  <li>
                    You acknowledge that each company will use and disclose your
                    information in accordance with its own privacy notice below,
                    and that you are over the age of 18.
                  </li>
                  <li>
                    You acknowledge that the Giveback is paid at Lemonade&apos;s
                    discretion.
                  </li>
                </ul>

                <h1>Want to Learn More?</h1>
                <p className="hc-pet-insurance__legal--links">
                  <a
                    href="https://static.chewy.com/lib/cms/1.0.0/pdf/TrupanionPriv20211130.pdf"
                    rel="noopener noreferrer"
                    title="Download Trupanion's Privacy Notice"
                    target="_blank"
                    download
                  >
                    Trupanion&apos;s Privacy Notice
                  </a>
                  <a
                    href="https://www.lemonade.com/privacy-policy"
                    rel="noopener noreferrer"
                    title="View Lemonade's Privacy Notice"
                    target="_blank"
                    download
                  >
                    Lemonade&apos;s Privacy Notice
                  </a>
                  <a
                    href="https://static.chewy.com/lib/cms/1.0.0/pdf/ChewyInsSvcsPrivacy.pdf"
                    rel="noopener noreferrer"
                    title="Download Chewy's Privacy Notice"
                    target="_blank"
                    download
                  >
                    Chewy Insurance Services Privacy Notice
                  </a>
                  <a
                    href="https://www.lemonade.com/terms-of-service"
                    rel="noopener noreferrer"
                    title="View Lemonade's Terms of Service"
                    target="_blank"
                    download
                  >
                    Lemonade&apos;s Terms of Service
                  </a>
                  <a
                    href="https://www.chewy.com/app/content/privacy"
                    rel="noopener noreferrer"
                    title="View Chewy Privacy Notice"
                    target="_blank"
                    download
                  >
                    Chewy Privacy Notice
                  </a>
                </p>
              </div>
            </div>
            <div className="privacy-desktop">
              <p>
                <>
                  By providing your information to Chewy Insurance Services,
                  LLC. (&quot;Chewy Insurance&quot;) and/or Trupanion Managers
                  USA, Inc. (dba Trupanion Insurance Services, in California)
                  (&quot;Trupanion&quot;) and Lemonade Insurance Agency, LLC
                  (&quot;LIA&quot;) for the for the purpose of obtaining a quote
                  for your CarePlus Plan, you direct Chewy Insurance to share
                  that information with Trupanion and/or Lemonade, including the
                  personal, pet, and vet data you provided, along with your
                  email address of your Chewy account. By continuing, you direct
                  Chewy, Chewy Insurance, Trupanion and/or Lemonade to share the
                  information. You acknowledge that each company will use and
                  disclose your information in accordance with its own privacy
                  notice below, and that you are over the age of 18. You
                  acknowledge that the Giveback is paid at Lemonade&apos;s
                  discretion. You also agree to the Terms of Use for each:
                  Chewy, Chewy Insurance, Trupanion, and Lemonade.
                </>
              </p>
              <DesktopLegalLinks />
            </div>
          </div>
        ) : null}
        {prefix === 'AFFIDAVIT' ? (
          <div>
            <p>
              <>
                By purchasing, you agree to Chewy and either Trupanion or
                Lemonade’s Terms & Conditions and that all information is
                accurate as insurance fraud is subject to criminal penalties. In
                addition, by providing your information to Chewy Inc, LLC
                (“Chewy”), Chewy Insurance Services, LLC. (&quot;Chewy
                Insurance&quot;) and either Trupanion Managers USA, Inc. (dba
                Trupanion Insurance Services, in California)
                (&quot;Trupanion&quot;) or Lemonade Insurance Agency, LLC
                (&quot;LIA&quot;) for the purpose of servicing your CarePlus
                Plan, you direct Chewy Insurance and either Trupanion or
                Lemonade to share that information along with your email
                address. You acknowledge that each company will use and disclose
                your information in accordance with its own privacy notice
                below. and that you are over the age of 18. You also acknowledge
                that the Giveback is paid at Lemonade’s discretion.
              </>
            </p>
            <DesktopLegalLinks />
          </div>
        ) : null}
        {showMultiVendorSuffix && (
          <div>
            <p>
              IMPORTANT NOTICE: &copy;{new Date().getFullYear()} This policy is
              sold and administered by Chewy Insurance Services, LLC, a licensed
              insurance producer (CA license No. 6007025, NPN 19685062, licenses
              available{' '}
              <a
                href="https://www.chewy.com/app/content/insurance"
                title="Go to Chewy Insurance Licenses"
                rel="noopener noreferrer"
                target="_blank"
              >
                here
              </a>
              ), and one of either Trupanion Managers USA, Inc.
              (&quot;TMUI&quot;) (CA license No. 0G22803, NPN 9588590, licenses
              available{' '}
              <a
                href="https://trupanion.com/site/terms-of-use"
                title="Go to Trupanion Insurance Licenses"
                rel="noopener noreferrer"
                target="_blank"
              >
                here
              </a>
              ), and underwritten by American Pet Insurance Company
              (&quot;APIC&quot;) or ZPIC Insurance Company (&quot;ZPIC&quot;),
              with its main office at 6100 4th Ave S, Seattle, WA 98108 or
              Lemonade Insurance Agency, LLC (&quot;LIA&quot;) (licenses
              available{' '}
              <a
                href="https://www.lemonade.com/legal-stuff"
                title="Go to Lemonade Insurance Licenses"
                rel="noopener noreferrer"
                target="_blank"
              >
                here
              </a>
              ) and underwritten by Lemonade Insurance Company (&quot;LIC&quot;)
              or Metromile Insurance Company (&quot;MIC&quot;), with its main
              office at 5 Crosby Street, 3rd Floor, New York, NY 10013. TMUI,
              APIC, ZPIC, LIA, LIC, MIC and their respective affiliates are
              separate, independent of, and distinct from Chewy Insurance
              Services, LLC, and its affiliates.
            </p>
            {!prefix && <DesktopLegalLinks />}
          </div>
        )}
      </div>
    </div>
  );
};

export const DesktopLegalLinks = () => (
  <p className="hc-pet-insurance__legal--links">
    <a
      href="https://static.chewy.com/lib/cms/1.0.0/pdf/ChewyInsSvcsPrivacy.pdf"
      rel="noopener noreferrer"
      title="Download Chewy's Privacy Notice"
      target="_blank"
      download
    >
      Chewy Insurance Services Privacy Notice
    </a>
    <a
      href="https://static.chewy.com/lib/cms/1.0.0/pdf/TrupanionPriv20211130.pdf"
      rel="noopener noreferrer"
      title="Download Trupanion's Privacy Notice"
      target="_blank"
      download
    >
      Trupanion&apos;s Privacy Notice
    </a>
    <a
      href="https://www.lemonade.com/privacy-policy"
      rel="noopener noreferrer"
      title="Lemonade's Privacy Notice"
      target="_blank"
    >
      Lemonade&apos;s Privacy Notice
    </a>
    <a
      href="https://www.chewy.com/app/content/privacy"
      rel="noopener noreferrer"
      title="Chewy Privacy Notice"
      target="_blank"
    >
      Chewy Privacy Notice
    </a>
  </p>
);
